import styled, { css } from "styled-components";
import { statusColors } from "./statusPalette";

const medium = css`
  font-family: "OurLexend-Medium", Helvetica, sans-serif;
  font-weight: normal;
`;

const semiBold = css`
  font-family: "OurLexend-SemiBold", Helvetica, sans-serif;
  font-weight: normal;
`;

const bold = css`
  font-family: "OurLexend-Bold", Helvetica, sans-serif;
  font-weight: normal;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(28, 28, 28, 0.06);
  position: relative;
  z-index: 1;
`;

export const BackWrap = styled.div`
  display: flex;
  align-items: center;

  & > div {
    margin-right: 0 !important;
  }
`;

export const HeaderTitle = styled.div`
  ${semiBold}
  font-size: 16px;
  line-height: 22px;
  color: #293142;
`;

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background: #f4f6fb;
  height: calc(100vh - 60px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  /* without this the cards shrink to fit the height instead of scrolling */
  & > * {
    flex-shrink: 0;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(28, 28, 28, 0.06);
`;

// zero-height spacer; the 1px dashed line is drawn just above its position
export const Divider = styled.div`
  position: relative;
  height: 0;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: -1px;
    height: 0;
    border-top: 1px dashed #e6e9ef;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
  line-height: 16px;
  color: #293142;

  /* the global stylesheet resets div/span to 1.6rem, so size them explicitly */
  & > span {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const InfoValue = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  line-height: 16px;
`;

export const HistoryTitle = styled.div`
  ${bold}
  font-size: 13px;
  line-height: 16px;
  color: #293142;
`;

export const HistoryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const HistoryDate = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #293142;
`;

export const HistoryReason = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  line-height: 14px;
  color: #b48535;

  & > span {
    font-size: 12px;
    line-height: 14px;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const SummaryCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(28, 28, 28, 0.06);
  overflow: hidden;
`;

export const TagRow = styled.div`
  padding: 0 16px 8px;
`;

export const Pill = styled.div`
  ${medium}
  width: fit-content;
  padding: 4px 8px;
  border-radius: 0 0 4px 4px;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  background: ${(props) => statusColors(props.status).bg};
  color: ${(props) => statusColors(props.status).fg};
`;

export const SummaryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: ${(props) => (props.hasTag ? "0 16px 12px" : "16px 16px 12px")};
  border-bottom: 0.5px solid #e6e9ef;
`;

export const SummaryDate = styled.div`
  ${bold}
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.01em;
  color: #293142;
`;

export const SummaryCount = styled.div`
  font-size: 13px;
  line-height: 16px;
  color: #767c8f;
`;

export const SummaryAmount = styled.div`
  ${bold}
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.01em;
  white-space: nowrap;
  color: #293142;
`;

export const TxnList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
`;

export const TxnRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  opacity: ${(props) => (props.$busy ? 0.6 : 1)};
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
`;

export const TxnTitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #293142;
`;

export const TxnId = styled.div`
  margin-top: 4px;
  font-size: 12px;
  line-height: 14px;
  color: #767c8f;
  word-break: break-all;
`;

export const TxnAmount = styled.div`
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  color: #293142;
`;
